module.exports = __webpack_public_path__ + "img/Icon Opportunity prioritization.8cfd1d58.svg";